import { helper } from "@template/utils";

const regexMap = {
    passwordRegex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\W_]+$/,
    userRegex : /^(?=.*?[A-Za-z])(?=.*?[0-9])(?!.*\s)[A-Za-z0-9_]{6,25}$/,
    referCodeRegex : /^\d+$/,
    withdrawPasswordRegex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,20}$/,
    referCodeRegex : /^\d+$/
};

const validate = {
    areFieldsValid(type, prop, prop2, prop3, prop4, prop5, prop6, prop7) {
        const errorObj = {};
    
        const addError = (type, error, lang) => {
            if (!errorObj[type]) {
                errorObj[type] = [];
            }
            errorObj[type].push({ error, lang });
        };
    
        const validateMobile = (mobile) => {
            if (mobile?.length !== 10) {
                addError('mobile', 'Mobile Number Should Be Of 10 Digits.', 'mobile-number-should-be-of-10-digits');
            }
        };
    
        const validatePassword = (password) => {
            if (password?.length < 8) {
                addError('password', 'Password Must Be Of Minimum 8 Characters and Maximum 20 Characters.', 'pass-min-8-max-20');
            }
            if (!helper.testRegex(regexMap.passwordRegex, password)) {
                addError('password', 'Password Must Contain Alphabets, Numbers, And At Least 1 In Capital Case, And 1 In Lower Case.', 'pass-alpha-num-1-caps');
            }
        };

        //Self Password
        const validateSelfPassword = (password) => {
            if (!password?.length) {
                addError('selfPassword', 'Please Enter Self Password', 'please-enter-self-password');
            }
            // if (!helper.testRegex(regexMap.passwordRegex, password)) {
            //     addError('selfPassword', 'Self Password Must Contain Alphabets, Numbers, And At Least 1 In Capital Case.', 'pass-alpha-num-1-caps');
            // }
        };

        // Withdraw password -----------------------------------------------
        const validateWithdrawPassword = (password) => {
            if (password?.length < 8) {
                addError('withdrawPassword', 'Withdraw Password Must Be Of Minimum 8 Characters And Maximum 20 Characters.', 'pass-min-8-max-20');
            }
            if (!helper.testRegex(regexMap.withdrawPasswordRegex, password)) {
                addError('withdrawPassword', 'Withdraw Password Must Contain Alphabets, Numbers,At Least 1 Special Character And At Least 1 In Capital Case & lower case', 'pass-alpha-num-1-caps');
            }
        };
        // ------------------------------------------------------------------
        const checkPasswordMatch = (password, confirmPassword) => {
            if (password !== confirmPassword) {
                addError('confirmPassword', 'Password Mismatched.', 'password-mismatched');
            }
        };
        const checkWithdrawPasswordMatch = (password, confirmPassword) => {
            if (password !== confirmPassword) {
                addError('confirmWithdrawPassword', 'Withdraw Password Mismatched.', 'password-mismatched');
            }
        };
        // Validation for each auth type
        

        if (type == 'only-mobile') {
            const mobile = prop;
            validateMobile(mobile);
        }

        if (type === 'login') {
            const tab = prop, mobile = prop2, userId = prop3, password = prop4, otp = prop5, type = prop6;
            if (tab == 1 && mobile === '') {
                addError('mobile', 'Please Enter Mobile Number', 'please-enter-mobile-number');
            }else if(type != 'password') {
                validateMobile(mobile);
            }
            if (tab == 2 && (userId == '' || userId == null)) {
                addError('userId', 'Please Enter User ID', 'please-enter-user-id');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            }
            if (tab == 1 && otp === '') {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (tab == 1 && otp != '' && otp?.length != 6) {
                addError('otp', 'Please Enter 6 Digit OTP', 'otp-6-digit-msg');
            }
        }
        
        if (type === 'signup') {
            const mobile = prop, otp = prop2, userId = prop3, password = prop4, confirmPassword = prop5, referCode = prop6;
            validateMobile(mobile);
            if (otp === '') {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (otp != '' && otp?.length != 6) {
                addError('otp', 'Please Enter 6 Digit OTP', 'please-enter-otp-6');
            }
            if (userId === '') {
                addError('userId', 'Please Enter User ID', 'please-enter-user-id');
            } else if (userId && (userId?.length < 6 || userId?.length > 25)) {
                addError('userId', 'User ID Must Be Between 6 To 25 Characters', 'user-id-6-to-25');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            } else {
                validatePassword(password);
            }
            if (password !== '' && confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (password !== '' && confirmPassword !== '') {
                checkPasswordMatch(password, confirmPassword);
            }
            if (referCode && !helper.testRegex(regexMap.referCodeRegex, referCode)) {
                addError('referCode', 'The Refer code must be numeric', 'refer-valid-msg');
            } 
        }
    
        if (type === 'forgot-password') {
            const mobile = prop, otp = prop2, password = prop3, confirmPassword = prop4;
            validateMobile(mobile);
            if (otp === '') {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (otp != '' && otp?.length != 6) {
                addError('otp', 'Please Enter 6 Digit OTP', 'please-enter-otp-6');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            } else {
                validatePassword(password);
            }
            if (password !== '' && confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (password !== '' && confirmPassword !== '') {
                checkPasswordMatch(password, confirmPassword);
            }
        }
    
        if (type === 'change-password') {
            const oldPassword = prop, newPassword = prop2, confirmPassword = prop3;
            //  withdrawPassword = prop4, confirmWithdrawPassword = prop5, isVerifyWithdrawPassowrd = prop6;
            if (oldPassword === '') {
                addError('oldPassword', 'Please Enter Current Password', 'please-enter-old-password');
            }
            if (newPassword === '') {
                addError('password', 'Please Enter New Password', 'please-enter-new-password');
            } else {
                validatePassword(newPassword);
            }
            if (newPassword !== '' && confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (newPassword !== '' && confirmPassword !== '') {
                checkPasswordMatch(newPassword, confirmPassword);
            }

            // withdraw pass
            // if(isVerifyWithdrawPassowrd) {
            //     if (withdrawPassword === '') {
            //         addError('withdrawPassword', 'Please Enter Withdraw Password', 'please-enter-withdraw-password');
            //     } else {
            //         validateWithdrawPassword(withdrawPassword);
            //     }
            //     if (withdrawPassword !== '' && confirmWithdrawPassword === '') {
            //         addError('confirmWithdrawPassword', 'Please Enter Confirm Withdraw Password', 'please-enter-confirm-password');
            //     }
            //     if (withdrawPassword !== '' && confirmWithdrawPassword !== '') {
            //         checkWithdrawPasswordMatch(withdrawPassword, confirmWithdrawPassword);
            //     }
            // }

        }
        // Withdraw password
        if (type === 'withdraw-password') {
            const otp = prop, password = prop2, confirmPassword = prop3;
            if (!otp) {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (otp && otp?.length != 6) {
                addError('otp', 'Please Enter 6 Digit OTP', 'please-enter-otp-6');
            }
            if (!password) {
                addError('withdrawPassword', 'Please Enter Withdraw Password', 'please-enter-withdraw-password');
            } else {
                validateWithdrawPassword(password);
            }
            if (!confirmPassword){
                addError('confirmWithdrawPassword', 'Please Enter Confirm Withdraw Password.', 'please-enter-confirm-withdraw-password');
            }
            if (password && confirmPassword) {
                checkWithdrawPasswordMatch(password, confirmPassword);
            }
        }

        //display name
        if (type === 'display-name') {
            const userId = prop
            if (userId === '') {
                addError('userId', 'Please Enter Display Name', 'please-enter-user-name');
            } else if (userId?.length < 6) {
                addError('userId', 'Display Name Must Contain Only Alphabets And Numbers And Be Between 6 To 15 Characters', 'display-name-id-alphabets-numbers-and-between-6-to-15-characters');
            }
        }

        // affiliate
        if (type === 'affiliate') {
            const mobile = prop, otp = prop2, userId = prop3, password = prop4, confirmPassword = prop5, selfPassword = prop6, isAffiliateToggle = prop7;
            if(isAffiliateToggle){
                validateMobile(mobile);
                if (mobile?.length && otp?.filter(item => item == '')?.length == 6) {
                    addError('otp', 'Please Enter OTP', 'please-enter-otp');
                }
                if (mobile?.length && otp?.filter(item => item == '')?.length != 6 && !otp?.every(item => item != '')) {
                    addError('otp', 'Please Enter 6 Digit OTP', 'please-enter-otp-6');
                }
            }
            if (userId === '') {
                addError('userId', 'Please Enter User ID', 'please-enter-user-name');
            } else if (userId && (userId?.length < 6 || userId?.length > 25)) {
                addError('userId', 'User ID Must Be Between 6 To 25 Characters', 'user-id-6-to-25');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            } else {
                validatePassword(password);
            }
            if (password !== '' && confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (password !== '' && confirmPassword !== '') {
                checkPasswordMatch(password, confirmPassword);
            }
            if (selfPassword === '') {
                addError('selfPassword', 'Please Enter Self Password', 'please-enter-self-password');
            } else {
                validateSelfPassword(selfPassword);
            }
        }

                if (type === 'update-phone-number') {
            const oldPhoneNumber = prop, oldPhoneNumberOtp = prop2,newPhoneNumber = prop3,newPhoneNumberOtp = prop4;
            
            const validatePhone = (phone, fieldName) => {
                if (!phone || phone.length !== 10) {
                    addError(fieldName, 'Phone Number Should Be Of 10 Digits.', 'mobile-number-should-be-of-10-digits');
                    return false;
                }
                return true;
            };
            const validateOtp = (otp, phone, fieldName) => {
                if (phone?.length === 10) {
                    if (!otp || otp.length === 0) {
                        addError(fieldName, 'Please Enter OTP', 'please-enter-otp');
                    } else if (otp.length !== 6) {
                        addError(fieldName, 'Please Enter 6 Digit OTP', 'otp-6-digit-msg');
                    }
                }
            };            
            // Validate Old Phone
            const isOldPhoneValid = validatePhone(oldPhoneNumber, 'oldPhoneNumber');
            if (isOldPhoneValid) {
                validateOtp(oldPhoneNumberOtp, oldPhoneNumber, 'oldOtp');
            }
            // Validate New Phone
            const isNewPhoneValid = validatePhone(newPhoneNumber, 'newPhoneNumber');
            if (isNewPhoneValid) {
                validateOtp(newPhoneNumberOtp, newPhoneNumber, 'newOtp');
            }
        }
        return errorObj;
    }
    
    
};
export default validate;